import { ExperienceTemplateRenderer, TemplateComponent, TemplateComponentProps } from 'experience-template-renderer-react';
import * as React from 'react';

import { ViewLarge, Viewport, ViewSmall } from '@shared-ui/viewport-context';

import { UitkLayoutFlex } from 'uitk-react-layout-flex';

export interface ListViewLayoutProps extends TemplateComponentProps {
  templateComponent: TemplateComponent;
}

export const ListViewLayout: React.FC<TemplateComponentProps> = ({ templateComponent: { children } }) => (
  <Viewport>
    <ViewLarge>
      <UitkLayoutFlex direction="row">
        <ExperienceTemplateRenderer templateComponents={children} />
      </UitkLayoutFlex>
    </ViewLarge>
    <ViewSmall>
      <UitkLayoutFlex direction="column">
        <ExperienceTemplateRenderer templateComponents={children} />
      </UitkLayoutFlex>
    </ViewSmall>
  </Viewport>
);
